import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAuthorization } from "../../../services/config";
import { updateLoading } from "../loader";
import API_ROUTES from "../../../constants/apiRoutes";
import { ToastNotifySuccess } from "../../../components/CommonComponents/Toast/ToastNotify";

const {
  V1: {
    GET_FAVOURITE_PRODUCTS,
    FAVOURITE_LISTING
     } = {},
} = API_ROUTES;


const fetchFavProducts = createAsyncThunk(
  "favouriteProducts/get",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true, isSessionKey: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(`${GET_FAVOURITE_PRODUCTS}?page_size=100`);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const listFavProducts = createAsyncThunk(
  "favouriteProducts/list",
  async (params, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true, isSessionKey: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(`${FAVOURITE_LISTING}${params}`);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const setFavourite = createAsyncThunk(
  "favouriteProducts/add",
  async (payload, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true, isSessionKey: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(GET_FAVOURITE_PRODUCTS, payload);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);
const removeFavourite = createAsyncThunk(
  "favouriteProducts/remove",
  async (param, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true, isSessionKey: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.delete(`${GET_FAVOURITE_PRODUCTS}${param}`);
      dispatch(updateLoading(false));
      ToastNotifySuccess("Piece removed from favorites.")
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

export { fetchFavProducts, setFavourite, removeFavourite, listFavProducts };
